import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPin12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPin12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m7.643 5.802-.355.238-.071.417-.392 2.276-3.663-3.615 2.307-.386.422-.071.241-.35 1.789-2.596 2.352 2.321zM2.994 4.139 5.3 3.752l1.79-2.596a1.015 1.015 0 0 1 1.544-.144l2.352 2.322a.986.986 0 0 1-.146 1.524L8.21 6.623 7.817 8.9c-.137.796-1.126 1.107-1.704.537L4.697 8.038a.5.5 0 0 1-.06.07L1.86 10.85a.51.51 0 0 1-.712 0 .49.49 0 0 1 0-.702l2.78-2.743a.5.5 0 0 1 .07-.058L2.451 5.82c-.578-.57-.263-1.547.543-1.682"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPin12);
